// Flat UI string catalogue. Access via t("key") from LanguageProvider.
export const STRINGS = {
  "brand.name": { el: "Δρ. Λουκία Αποστολακοπούλου", en: "Dr. Loukia Apostolakopoulou" },
  "brand.role": { el: "Νευρολόγος · Αθήνα", en: "Neurologist · Athens" },

  "nav.home": { el: "Αρχική", en: "Home" },
  "nav.about": { el: "Βιογραφικό", en: "About" },
  "nav.services": { el: "Εξειδίκευση", en: "Specialisation" },
  "nav.conditions": { el: "Παθήσεις", en: "Conditions" },
  "nav.conditionsServices": { el: "Παθήσεις & Υπηρεσίες", en: "Conditions & Services" },
  "nav.servicesGroup": { el: "Υπηρεσίες", en: "Services" },
  "nav.publications": { el: "Δημοσιεύσεις", en: "Publications" },
  "nav.articles": { el: "Άρθρα", en: "Articles" },
  "nav.faq": { el: "Συχνές Ερωτήσεις", en: "FAQ" },
  "nav.contact": { el: "Επικοινωνία", en: "Contact" },
  "nav.book": { el: "Κλείστε Ραντεβού", en: "Book Appointment" },
  "nav.menu": { el: "Μενού", en: "Menu" },

  "cta.book": { el: "Κλείστε Ραντεβού", en: "Book Appointment" },
  "cta.bookShort": { el: "Ραντεβού", en: "Book" },
  "cta.learnMore": { el: "Μάθετε περισσότερα", en: "Learn more" },
  "cta.viewAll": { el: "Δείτε τα όλα", en: "View all" },
  "cta.contact": { el: "Επικοινωνήστε", en: "Get in touch" },
  "cta.readMore": { el: "Διαβάστε περισσότερα", en: "Read more" },
  "cta.allServices": { el: "Όλες οι υπηρεσίες", en: "All services" },
  "cta.allConditions": { el: "Όλες οι παθήσεις", en: "All conditions" },
  "cta.meetDoctor": { el: "Γνωρίστε τη γιατρό", en: "Meet the doctor" },
  "service.examTypes": { el: "Τρόποι εξέτασης", en: "Ways to be examined" },
  "service.duration": { el: "Διάρκεια", en: "Duration" },
  "service.priceLabel": { el: "Κόστος", en: "Cost" },
  "service.bookOnline": { el: "Άμεση Online Κράτηση", en: "Book online now" },
  "service.byRequest": { el: "Κατόπιν επικοινωνίας", en: "By appointment request" },
  "condition.book.eyebrow": { el: "ΚΛΕΙΣΤΕ ΕΠΙΣΚΕΨΗ", en: "Book a visit" },
  "condition.book.title": { el: "Ξεκινήστε τη φροντίδα σας", en: "Start your care" },
  "condition.book.recommended": { el: "Προτεινόμενο για αυτή την πάθηση", en: "Recommended for this condition" },
  "condition.book.help": { el: "Δεν είστε σίγουροι ποια επίσκεψη χρειάζεστε; Καλέστε μας για καθοδήγηση.", en: "Not sure which visit you need? Call us for guidance." },

  "banner.english": { el: "", en: "" },
  "banner.englishAsk": { el: "Continue in English?", en: "Continue in English?" },
  "banner.englishYes": { el: "Switch to English", en: "Switch to English" },
  "banner.dismiss": { el: "Όχι, ευχαριστώ", en: "No, thanks" },

  "lang.el": { el: "ΕΛ", en: "ΕΛ" },
  "lang.en": { el: "EN", en: "EN" },
  "lang.switch": { el: "Αλλαγή γλώσσας", en: "Change language" },

  "home.hero.eyebrow": { el: "ΝΕΥΡΟΛΟΓΟΣ ΑΘΗΝΑ", en: "Neurologist in Athens" },
  "home.hero.lead": {
    el: "Εξειδικευμένη νευρολογική φροντίδα στην Επιληψία, το Ηλεκτροεγκεφαλογράφημα και τις Κεφαλαλγίες — με διαγνωστική ακρίβεια και ολιστική, ανθρωποκεντρική προσέγγιση.",
    en: "Specialist neurological care in Epilepsy, EEG and Headaches — combining diagnostic precision with a holistic, patient-centred approach.",
  },
  "home.trust.title": { el: "Εκπαίδευση σε Κέντρα Αριστείας", en: "Trained at Centers of Excellence" },
  "home.services.eyebrow": { el: "ΤΟΜΕΙΣ ΦΡΟΝΤΙΔΑΣ", en: "Areas of Care" },
  "home.services.title": { el: "Υπηρεσίες Ιατρείου", en: "Clinical Services" },
  "home.services.lead": {
    el: "Ολοκληρωμένη νευρολογική αξιολόγηση και εξειδικευμένες θεραπείες, προσαρμοσμένες στις ανάγκες κάθε ασθενούς.",
    en: "Comprehensive neurological assessment and specialised treatments, tailored to each patient's needs.",
  },
  "home.philosophy.eyebrow": { el: "ΘΕΡΑΠΕΥΤΙΚΟ ΟΡΑΜΑ", en: "Therapeutic Vision" },
  "home.conditions.eyebrow": { el: "ΠΑΘΗΣΕΙΣ ΠΟΥ ΑΝΤΙΜΕΤΩΠΙΖΟΥΜΕ", en: "Conditions We Treat" },
  "home.conditions.title": { el: "Εξειδίκευση ανά Πάθηση", en: "Focused Expertise by Condition" },
  "home.articles.eyebrow": { el: "ΕΝΗΜΕΡΩΣΗ", en: "Insights" },
  "home.articles.title": { el: "Άρθρα & Δημοσιεύσεις", en: "Articles & Publications" },
  "home.locations.eyebrow": { el: "ΙΑΤΡΕΙΑ", en: "Locations" },
  "home.locations.title": { el: "Πού θα μας βρείτε", en: "Where to find us" },
  "home.finalcta.title": { el: "Κλείστε το ραντεβού σας", en: "Book your appointment" },
  "home.finalcta.lead": {
    el: "Αφιερώνουμε στον κάθε ασθενή τον χρόνο που πραγματικά χρειάζεται. Επικοινωνήστε μαζί μας για να προγραμματίσουμε την επίσκεψή σας.",
    en: "We dedicate to each patient the time they genuinely need. Get in touch to arrange your visit.",
  },

  "loc.hours": { el: "Ώρες Λειτουργίας", en: "Opening Hours" },
  "loc.address": { el: "Διεύθυνση", en: "Address" },
  "loc.byAppointment": { el: "Κατόπιν ραντεβού", en: "By appointment" },
  "loc.getDirections": { el: "Οδηγίες πρόσβασης", en: "Get directions" },
  "loc.floor": { el: "όροφος", en: "floor" },

  "services.eyebrow": { el: "ΕΞΕΙΔΙΚΕΥΣΗ", en: "Specialisation" },
  "services.title": { el: "Τομείς Εξειδίκευσης", en: "Areas of Specialisation" },
  "services.whatIs": { el: "Τι είναι", en: "What it is" },
  "services.includes": { el: "Τι περιλαμβάνει", en: "What it includes" },
  "services.bookable": { el: "Άμεση online κράτηση", en: "Online booking available" },
  "services.requestOnly": { el: "Κατόπιν επικοινωνίας", en: "By request" },
  "services.duration": { el: "Διάρκεια", en: "Duration" },
  "services.min": { el: "λεπτά", en: "min" },
  "services.howItWorks.title": { el: "Πώς γίνεται η επίσκεψη", en: "How the visit works" },

  "service.overview": { el: "Επισκόπηση", en: "Overview" },
  "service.included": { el: "Τι περιλαμβάνει", en: "What this includes" },
  "service.whoFor": { el: "Σε ποιους απευθύνεται", en: "Who it's for" },
  "service.faqTitle": { el: "Συχνές ερωτήσεις", en: "Frequently asked" },
  "service.learnMore": { el: "Περισσότερα για την υπηρεσία", en: "More about this service" },

  "conditions.eyebrow": { el: "ΠΑΘΗΣΕΙΣ", en: "Conditions" },
  "conditions.title": { el: "Νευρολογικές Παθήσεις", en: "Neurological Conditions" },
  "conditions.lead": {
    el: "Ενημερωτικές σελίδες για τις παθήσεις στις οποίες εστιάζει το ιατρείο. Κάθε πληροφορία είναι γενικής φύσεως και δεν υποκαθιστά την εξατομικευμένη ιατρική αξιολόγηση.",
    en: "Informational pages on the conditions the practice focuses on. All information is of a general nature and does not replace an individualised medical assessment.",
  },
  "conditions.faqTitle": { el: "Συχνές ερωτήσεις", en: "Frequently asked" },
  "conditions.relatedCta": { el: "Χρειάζεστε νευρολογική αξιολόγηση;", en: "Need a neurological assessment?" },
  "conditions.onThisPage": { el: "Σε αυτή τη σελίδα", en: "On this page" },
  "conditions.whenToSee": { el: "Πότε να απευθυνθείτε σε νευρολόγο", en: "When to see a neurologist" },

  "pub.eyebrow": { el: "ΕΡΕΥΝΑ & ΔΗΜΟΣΙΕΥΣΕΙΣ", en: "Research & Publications" },
  "pub.title": { el: "Επιστημονικό Έργο", en: "Scientific Work" },
  "pub.selected": { el: "Επιλεγμένες Δημοσιεύσεις", en: "Selected Publications" },
  "pub.all": { el: "Πλήρης Κατάλογος Δημοσιεύσεων", en: "Full Publication List" },
  "pub.studies": { el: "Κλινικές Μελέτες", en: "Clinical Studies" },
  "pub.memberships": { el: "Επιστημονικές Εταιρείες", en: "Professional Memberships" },
  "pub.conferences": { el: "Συνεδριακή Δραστηριότητα", en: "Conference Activity" },
  "pub.viewDoi": { el: "Προβολή (DOI)", en: "View (DOI)" },

  "faq.eyebrow": { el: "ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ", en: "Frequently Asked Questions" },
  "faq.title": { el: "Απαντήσεις στις ερωτήσεις σας", en: "Answers to your questions" },

  "articles.eyebrow": { el: "ΑΡΘΡΑ", en: "Articles" },
  "articles.title": { el: "Άρθρα & Αρθρογραφία", en: "Articles & Writing" },
  "articles.external": { el: "Εξωτερικός σύνδεσμος", en: "External link" },
  "articles.readAt": { el: "Διαβάστε το άρθρο", en: "Read the article" },

  "book.eyebrow": { el: "ΚΡΑΤΗΣΗ ΡΑΝΤΕΒΟΥ", en: "Book an Appointment" },
  "book.title": { el: "Προγραμματίστε την επίσκεψή σας", en: "Schedule your visit" },
  "book.lead": {
    el: "Επιλέξτε τον τύπο επίσκεψης που σας ενδιαφέρει. Η ασφαλής online κράτηση με προπληρωμή ολοκληρώνεται σύντομα· έως τότε, επικοινωνήστε μαζί μας τηλεφωνικά ή μέσω της φόρμας.",
    en: "Choose the type of visit you need. Secure online booking with prepayment is being finalised; until then, please contact us by phone or through the form.",
  },
  "book.online": { el: "Επισκέψεις με online κράτηση", en: "Visits available for online booking" },
  "book.request": { el: "Υπηρεσίες κατόπιν επικοινωνίας", en: "Services by request" },
  "book.soon": { el: "Online κράτηση σύντομα", en: "Online booking soon" },
  "book.priceNote": {
    el: "Οι τιμές είναι ενδεικτικές και οριστικοποιούνται πριν την επίσκεψη.",
    en: "Prices are indicative and confirmed prior to the visit.",
  },

  "contact.eyebrow": { el: "ΕΠΙΚΟΙΝΩΝΙΑ", en: "Contact" },
  "contact.title": { el: "Επικοινωνήστε μαζί μας", en: "Get in touch" },
  "contact.firstVisit": { el: "Η πρώτη σας επίσκεψη", en: "Your first visit" },
  "contact.access": { el: "Πρόσβαση", en: "Getting there" },
  "contact.form.title": { el: "Στείλτε μας μήνυμα", en: "Send us a message" },
  "contact.form.name": { el: "Ονοματεπώνυμο", en: "Full name" },
  "contact.form.email": { el: "Email", en: "Email" },
  "contact.form.phone": { el: "Τηλέφωνο", en: "Phone" },
  "contact.form.message": { el: "Μήνυμα", en: "Message" },
  "contact.form.consent": {
    el: "Συναινώ στην επεξεργασία των στοιχείων μου για τον σκοπό της επικοινωνίας, σύμφωνα με την Πολιτική Απορρήτου.",
    en: "I consent to the processing of my details for the purpose of this enquiry, in line with the Privacy Policy.",
  },
  "contact.form.submit": { el: "Αποστολή μηνύματος", en: "Send message" },
  "contact.form.sending": { el: "Αποστολή…", en: "Sending…" },
  "contact.form.success": { el: "Το μήνυμά σας εστάλη. Θα επικοινωνήσουμε σύντομα.", en: "Your message has been sent. We will be in touch soon." },
  "contact.form.error": { el: "Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά ή τηλεφωνήστε μας.", en: "Something went wrong. Please try again or call us." },
  "contact.form.consentRequired": { el: "Παρακαλούμε αποδεχθείτε την επεξεργασία δεδομένων για να συνεχίσετε.", en: "Please accept data processing to continue." },

  "footer.tagline": {
    el: "Εξειδικευμένη νευρολογική φροντίδα στην Αθήνα — Επιληψία, ΗΕΓ & Κεφαλαλγίες.",
    en: "Specialist neurological care in Athens — Epilepsy, EEG & Headaches.",
  },
  "footer.explore": { el: "Πλοήγηση", en: "Explore" },
  "footer.legalCol": { el: "Νομικά", en: "Legal" },
  "footer.locations": { el: "Ιατρεία", en: "Locations" },
  "footer.reviews": { el: "Αξιολογήσεις στο Doctoranytime", en: "Reviews on Doctoranytime" },
  "footer.rights": { el: "Με επιφύλαξη παντός δικαιώματος.", en: "All rights reserved." },
  "footer.license": {
    el: "Αριθμός Μητρώου (Ι.Σ.Α.)",
    en: "Medical License (Athens M.A.)",
  },

  "legal.cancellation": { el: "Πολιτική Ακυρώσεων & Επιστροφών", en: "Cancellation & Refund Policy" },
  "legal.payment": { el: "Πολιτική Πληρωμών", en: "Payment Policy" },
  "legal.privacy": { el: "Πολιτική Απορρήτου", en: "Privacy Policy" },
  "legal.terms": { el: "Όροι Χρήσης", en: "Terms of Use" },
  "legal.cookies": { el: "Πολιτική Cookies", en: "Cookie Policy" },

  "cookie.text": {
    el: "Χρησιμοποιούμε απαραίτητα cookies και, με την άδειά σας, ανώνυμα στατιστικά χρήσης για τη βελτίωση του ιστοτόπου. Δεν χρησιμοποιούμε διαφημιστική παρακολούθηση.",
    en: "We use essential cookies and, with your permission, anonymous usage analytics to improve the website. We do not use advertising tracking.",
  },
  "cookie.accept": { el: "Αποδοχή στατιστικών", en: "Accept analytics" },
  "cookie.essentialOnly": { el: "Μόνο απαραίτητα", en: "Essential only" },

  "notfound.title": { el: "Η σελίδα δεν βρέθηκε", en: "Page not found" },
  "notfound.lead": { el: "Η σελίδα που ζητήσατε δεν υπάρχει ή έχει μετακινηθεί.", en: "The page you requested does not exist or has moved." },
  "notfound.home": { el: "Επιστροφή στην αρχική", en: "Back to home" },

  "common.disclaimer": {
    el: "Οι πληροφορίες του ιστότοπου είναι ενημερωτικού χαρακτήρα και δεν υποκαθιστούν την ιατρική συμβουλή.",
    en: "The information on this website is for general guidance only and does not constitute medical advice.",
  },

  "nav.doctor": { el: "Η Γιατρός", en: "The Doctor" },
  "nav.practice": { el: "Το Ιατρείο", en: "The Practice" },

  "audio.enable": { el: "Ήρεμος ήχος περιβάλλοντος", en: "Calm ambient sound" },
  "audio.disable": { el: "Σίγαση ήχου", en: "Mute sound" },

  "affiliations.eyebrow": { el: "ΕΚΠΑΙΔΕΥΣΗ & ΣΥΝΕΡΓΑΣΙΕΣ", en: "Training & Affiliations" },
  "affiliations.title": { el: "Εκπαιδευμένη σε κορυφαία κέντρα αριστείας", en: "Trained at leading centres of excellence" },
  "affiliations.note": {
    el: "Διεθνής εξειδίκευση και ενεργός κλινική & ερευνητική συνεργασία με αναγνωρισμένα ιδρύματα στην Ελλάδα και το εξωτερικό.",
    en: "International subspecialisation and active clinical & research collaboration with recognised institutions in Greece and abroad.",
  },

  "hero.reviewsLabel": { el: "επαληθευμένες αξιολογήσεις", en: "verified reviews" },
  "hero.credentialsLabel": { el: "Εκπαίδευση & Πιστοποιήσεις", en: "Training & Certification" },

  "reviews.close": { el: "Κλείσιμο", en: "Close" },
  "reviews.allTitle": { el: "Όλες οι αξιολογήσεις ασθενών", en: "All patient reviews" },
  "reviews.allLead": {
    el: "Συγκεντρωτικές, πραγματικές αξιολογήσεις από Google, Doctoranytime & Instadoctor, ταξινομημένες κατά ημερομηνία.",
    en: "Aggregated, genuine reviews from Google, Doctoranytime & Instadoctor, sorted by date.",
  },

  "loc.directions": { el: "Οδηγίες πρόσβασης", en: "Get directions" },

  "footer.credit": { el: "Σχεδιασμός & Ανάπτυξη από", en: "Designed & Developed by" },

  "reviews.eyebrow": { el: "ΑΞΙΟΛΟΓΗΣΕΙΣ ΑΣΘΕΝΩΝ", en: "Patient Reviews" },
  "reviews.title": { el: "Τι λένε οι ασθενείς", en: "What patients say" },
  "reviews.lead": {
    el: "Πραγματικές αξιολογήσεις ασθενών από Doctoranytime & Google.",
    en: "Genuine patient reviews from Doctoranytime & Google.",
  },
  "reviews.combinedNote": {
    el: "Συγκεντρωτική βαθμολογία από Doctoranytime & Google",
    en: "Combined rating across Doctoranytime & Google",
  },
  "reviews.readOn": { el: "Δείτε όλες τις αξιολογήσεις", en: "Read all reviews" },

  "practice.eyebrow": { el: "ΤΟ ΙΑΤΡΕΙΟ", en: "The Practice" },
  "practice.title": { el: "Ένας χώρος ηρεμίας & φροντίδας", en: "A space of calm & care" },
  "practice.lead": {
    el: "Το ιατρείο σχεδιάστηκε για να προσφέρει ηρεμία και οικειότητα — φυσικό φως, φυτά και ήπιες αποχρώσεις, ώστε κάθε επίσκεψη να ξεκινά με μια αίσθηση γαλήνης.",
    en: "The practice is designed to feel calm and personal — natural light, plants and soft tones, so every visit begins with a sense of ease.",
  },
  "practice.gallery": { el: "Ο χώρος μας", en: "Our space" },

  "book.step1": { el: "Υπηρεσία", en: "Service" },
  "book.step2": { el: "Τοποθεσία", en: "Location" },
  "book.step3": { el: "Ημ/νία & Ώρα", en: "Date & Time" },
  "book.step4": { el: "Στοιχεία", en: "Details" },
  "book.step5": { el: "Πληρωμή", en: "Payment" },
  "book.paymentTitle": { el: "Πληρωμή & Επιβεβαίωση", en: "Payment & confirmation" },
  "book.pay": { el: "Μετάβαση στην πληρωμή", en: "Proceed to payment" },
  "book.sendRequest": { el: "Αποστολή αιτήματος", en: "Send request" },
  "book.paymentSoon": { el: "Θα μεταφερθείτε στην ασφαλή σελίδα πληρωμής της Stripe. Το ραντεβού επιβεβαιώνεται μόλις ολοκληρωθεί η πληρωμή.", en: "You'll be taken to Stripe's secure payment page. Your appointment is confirmed once payment completes." },
  "book.requestLead": { el: "Συμπληρώστε τα στοιχεία σας και θα επικοινωνήσουμε μαζί σας για τον προγραμματισμό.", en: "Fill in your details and we'll get in touch to arrange the appointment." },
  "book.instant": { el: "Άμεση κράτηση", en: "Instant booking" },
  "book.onRequest": { el: "Κατόπιν επικοινωνίας", en: "By request" },
  "book.priceOnRequest": { el: "Κατόπιν επικοινωνίας", en: "On request" },
  "book.next": { el: "Συνέχεια", en: "Continue" },
  "book.back": { el: "Πίσω", en: "Back" },
  "book.backToServices": { el: "Πίσω στις υπηρεσίες", en: "Back to services" },
  "book.chooseService": { el: "Επιλέξτε τύπο επίσκεψης", en: "Choose your visit type" },
  "book.chooseLocation": { el: "Επιλέξτε ιατρείο", en: "Choose a location" },
  "book.chooseDateTime": { el: "Επιλέξτε ημερομηνία & ώρα", en: "Choose date & time" },
  "book.availableTimes": { el: "Διαθέσιμες ώρες", en: "Available times" },
  "book.noSlots": { el: "Δεν υπάρχουν διαθέσιμες ώρες αυτή την ημέρα. Επιλέξτε άλλη ημερομηνία.", en: "No available times on this day. Please pick another date." },
  "book.pickDate": { el: "Επιλέξτε πρώτα ημερομηνία", en: "Select a date first" },
  "book.slotTaken": { el: "Μη διαθέσιμη ώρα", en: "Time not available" },
  "book.yourDetails": { el: "Τα στοιχεία σας", en: "Your details" },
  "book.reason": { el: "Λόγος επίσκεψης (προαιρετικά)", en: "Reason for visit (optional)" },
  "book.summary": { el: "Σύνοψη ραντεβού", en: "Appointment summary" },
  "book.videoLabel": { el: "Μέσω βιντεοκλήσης", en: "Via video call" },
  "book.confirm": { el: "Υποβολή αιτήματος", en: "Submit request" },
  "book.submitting": { el: "Υποβολή…", en: "Submitting…" },
  "book.successTitle": { el: "Λάβαμε το αίτημά σας!", en: "We've received your request!" },
  "book.successLead": {
    el: "Θα επικοινωνήσουμε σύντομα τηλεφωνικά για να επιβεβαιώσουμε το ραντεβού σας.",
    en: "We will call you shortly to confirm your appointment.",
  },
  "book.newBooking": { el: "Νέο αίτημα", en: "New request" },
  "book.needConsents": { el: "Παρακαλούμε αποδεχθείτε τους όρους για να συνεχίσετε.", en: "Please accept the terms to continue." },
  "book.reqError": { el: "Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά ή τηλεφωνήστε μας.", en: "Something went wrong. Please try again or call us." },
  "book.policyConsent": {
    el: "Έχω διαβάσει και αποδέχομαι την Πολιτική Ακυρώσεων & Επιστροφών.",
    en: "I have read and accept the Cancellation & Refund Policy.",
  },
  "book.prepayNote": {
    el: "Για τις υπηρεσίες με σταθερή τιμή, η κράτηση ολοκληρώνεται με ασφαλή online προπληρωμή μέσω Stripe. Οι υπηρεσίες κατόπιν επικοινωνίας καταχωρούνται ως αίτημα.",
    en: "For fixed-price services, booking is completed with secure online prepayment via Stripe. On-request services are submitted as a request.",
  },
};
